import client from "./client";

export const sendEmail = async (data) => {
  return await client({
    url: `/auth/email/send`,
    method: "post",
    data,
  });
};

export const validateEmail = async (data) => {
  return await client({
    url: `/auth/email/validate`,
    method: "post",
    data,
  });
};
